// Reads the public /api/config endpoint once to learn whether PartsBase search
// is switched on for this deployment.
//
// Without this the panel renders everywhere and its only possible answer is
// "turned off" — which still costs a round trip, a tenant-scoped DB read, and a
// slot in the shared 20/min budget. Shaped after useDemoMode, which reads the
// same endpoint.

import { useEffect, useState } from 'react';

let cached: boolean | null = null;

export function usePartsBaseSearchEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(cached ?? false);

  useEffect(() => {
    if (cached !== null) return;
    let alive = true;
    fetch('/api/config')
      .then((r) => (r.ok ? r.json() : { partsBaseSearch: false }))
      .then((d) => {
        cached = Boolean(d?.partsBaseSearch);
        if (alive) setEnabled(cached);
      })
      .catch(() => {
        /* default to off on error — never render a paid affordance on a guess */
      });
    return () => {
      alive = false;
    };
  }, []);

  return enabled;
}
